import { Component } from '@angular/core';
import { map } from 'rxjs/operators';

import { EntityType } from '@shared/components/audit/models/audit-log';
import { ContactEventService } from '@features/contacts/services/contact-event.service';

@Component({
  selector: 'app-individual-audit-list',
  templateUrl: './individual-audit-list.component.html'
})
export class IndividualAuditListComponent {
  individualId$ = this.contactEventService.selectedContactInfo$.pipe(
    map(contactInfo => contactInfo.id)
  );
  entityType = EntityType.INDIVIDUAL;

  constructor(private contactEventService: ContactEventService) {}
} 